
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';

import App from './components/App';
import reducers from './reducers';
import { NavigationProvider } from './context/navigation';

//Site.css is te AI stuff

//The problem was tricky because webpack bundles CSS in a specific way, so we had to try several 
// approaches to find one that worked for both device detection and preventing the flash. The solution 
// of using dynamic import() with a promise to delay React rendering was the key to making it work 
// correctly on both your Android phone and desktop

// Device detection: Check if the user is on Android or any mobile device
// isAndroid specifically checks for Android in the user agent string
const isAndroid = /Android/i.test(navigator.userAgent);
// isMobile checks for any mobile device type OR screens 768px or smaller
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;

// Dynamically load the appropriate CSS file based on device type
// Using dynamic import() ensures only one CSS file is loaded, preventing conflicts
// Site2.css for mobile/Android, Site.css for desktop
const cssPromise = (isAndroid || isMobile) 
    ? import('./components/Site2.css')
    : import('./components/Site.css');



const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));
//const store = createStore(reducers, composeEnhancers(applyMiddleware()));


// TEMPORARY
//This statement allows you to evaluate all the store state from the browser webtools
//console, with instruction: store.getState(); from the console line.
//Hint: You need to click F12 to avoid the copyright warning flyout when on chrome browser.
//Uncomment this line so it can execute here,
//window.store = store;
//From chrome web tools console, run store.getState() from the console line.

// Wait for the CSS to fully load before rendering React
// This prevents FOUC (Flash of Unstyled Content) by ensuring styles are ready
cssPromise.then(() => {
    ReactDOM.render(
        <NavigationProvider>
            <Provider store={store}>
                <App />,
            </Provider>,
        </NavigationProvider>,
        // Tell react to take control of the root element
        document.querySelector('#root')
    );
});

